import i18n from 'Pods/Shared/I18n'

// Monthly subscription download allotment. Mirrors
// ItemFiles::CheckDownloadLimit::DOWNLOAD_LIMIT on the backend.
const SUBSCRIPTION_DOWNLOAD_LIMIT = 25

// Picks the correct download-limit error copy from a
// checkDownloadAvailabilityAndGetUrl response. Subscribers who hit their
// monthly cap get subscription-specific framing (monthly limit + reset date +
// individual-purchase path); everyone else keeps the free daily-limit message.
// The reset date can be missing (e.g. a trial subscriber with no paid payment
// yet), so use a date-less variant instead of rendering "resets on ." blank.
function downloadLimitMessage({ reason, resetDate, limit } = {}) {
  if (reason === 'subscription_limit') {
    const key = resetDate
      ? 'model.subscription.limit_reached_detailed'
      : 'model.subscription.limit_reached_detailed_no_date'

    return i18n.t(key, {
      ns: 'rails',
      limit: SUBSCRIPTION_DOWNLOAD_LIMIT,
      reset_date: resetDate,
    })
  }

  if (limit != null) {
    return i18n.t('model.download_limit_exceeded_tiered', { ns: 'rails', limit })
  }
  return i18n.t('model.download_limit_exceeded', { ns: 'rails' })
}

export default downloadLimitMessage
